import { render, staticRenderFns } from "./zgy-search.vue?vue&type=template&id=72dbd0f9&scoped=true&"
import script from "./zgy-search.vue?vue&type=script&lang=js&"
export * from "./zgy-search.vue?vue&type=script&lang=js&"
import style0 from "./zgy-search.vue?vue&type=style&index=0&id=72dbd0f9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dbd0f9",
  null
  
)

export default component.exports